// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProgramKitIssuance } from './program-kit-issuance';
import { ProgramUserGroup } from './program-user-group';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramKitIssuanceUserGroupMap extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key FK programKitIssuance */
  programKitIssuanceId!: string;
  /** Guid key FK programUserGroup */
  programUserGroupId!: string;
  /** FK programKitIssuanceId */
  programKitIssuance!: ProgramKitIssuance;
  /** FK programUserGroupId */
  programUserGroup!: ProgramUserGroup;
}

